import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import userLogo from "../../../assets/jobSeeker.png";
import location from "../../../assets/location.svg";
import date from "../../../assets/date.svg";
import Employees from "../../../assets/Employees.svg";
import joblogo from "../../../assets/joblogo.jpg";
import styles from "./style.module.css";
import moment from "moment/moment";
import { Badge } from "@mantine/core";

const JobCard = ({ data }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/job/${data._id}`);
  };
  console.log("data", data.createdBy);
  return (
    <div
      className={`d-flex  p-3 flex-column shadow bg-white  mb-3 ${styles.jobdet}`}
      onClick={handleClick}
    >
      <div className={`d-flex gap-3 ${styles.mobss}`}>
        <div className="text-center">
          <img
            src={
              data.createdBy?.companyProfileInfo.length === 0
                ? joblogo
                : data.createdBy?.companyProfileInfo?.[0]?.companyLogo
            }
            width="120px"
            height="120px"
            className="rounded-circle"
            style={{ border: "1px solid rgb(0,0,0,0.2)", padding: "2px" }}
            alt="joblogo"
          />
        </div>
        <div className="d-flex flex-column w-100">
          <div className="d-flex loc-s  justify-content-between">
            <div className="d-flex loc-s  justify-content-between w-100">
              <h5 className="text-info">{data.jobTitle}</h5>
              <Badge color="teal" size="lg">
                Applied
              </Badge>
            </div>
            <div className={`d-flex ${styles.applications} loc-s`}>
              <span
                className="text-dark"
                style={{
                  background: "#90EE90",
                  paddingInline: "7px",
                  borderRadius: "15px",
                }}
              >
                {/* {data.} */}
              </span>
            </div>
          </div>
          <div className={styles.locs}>
            <h6 style={{ color: "gray" }}>
              {data.createdBy?.companyProfileInfo.length === 0
                ? "Null"
                : data.createdBy?.companyProfileInfo?.[0]?.companyName}{" "}
            </h6>
          </div>
          <div className={`${styles.dateapplied}`}>
            <div className={styles.locs}>
              <img style={{ width: "15px" }} src={location} />
              <h6 className="mb-0">{data.empLocation.city}</h6>
            </div>
            <div className={styles.locs}>
              <img style={{ width: "18px" }} src={date} />
              <h6 className="mb-0">
                {new moment(data.createdDate).format("DD MMM YYYY")}
              </h6>
            </div>
            <div className={`${styles.locs}`}>
              <img style={{ width: "20px" }} src={Employees} />
              <h6 className="mb-0">
                {data.appliedCandidates.length} people applied
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(JobCard);
